export default {
    sortOrder: {
        asc: 'asc',
        desc: 'desc',
    },
}
